module.exports = __webpack_public_path__ + "static/media/video_verfication_audio.a4fe0c03.mp3";